import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import qs from 'qs';
import _ from 'lodash';
import Loader from '../components/Loader';
import Clipboard from 'clipboard';

class CollectionPromo extends Component {

    constructor(props) {
        super(props);
        const { location } = props;
        let discountCode
        let discountDesc
        let loading = false;

        this.state = {
            discountCode,
            discountDesc,
            loading,
            copied: false
        };
    }

    componentWillMount(){
    }

    componentDidMount() {        
        this.getPromo()
        new Clipboard('.copy-to-clipboard');
    }

    getPromo = () => {

        const { params: { collection } } = this.props;
        
        if(!collection || collection.length < 0){
            return;
        }

        this.setState({ loading: true });        
        return api(`/api/lookup/collection/promo/${collection.replace('&', '').replace('’', '')}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(result => {

            this.setState({ loading: false });

            if(result){
                this.setState({ 
                    discountCode: result.discountcode,
                    discountDesc: result.discountdesc });        
            } else {
                this.setState({ 
                    invalidPostcode: true,
                    result: undefined
                 });        
            }
        })
    }

    handlePostcodeChange = (event) => {
        this.setState({ postcode: event.target.value });
    }

    onCopyClicked = () => {
        this.setState({
            copied: true
        });
    }

    render() {
        const { error } = this.props
        const { announcement, discountCode, discountDesc, loading, invalidPostcode, copied } = this.state;
    
        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            {
                                error &&
                                <Alert bsStyle="danger">
                                    <div>{error}</div>
                                </Alert>
                            }
                            {
                                loading &&
                                <Loader />
                            }
                            {
                                !loading && announcement &&
                                <div>
                                    <label className="announcement-label">Announcement</label>
                                    <p>{announcement}</p>
                                </div>
                            }
                            {
                                !loading && discountCode &&
                                <div>
                                    <div><span className="announcement-discount-code">USE CODE: {discountCode}</span> 
                                    <button className="copy-to-clipboard" onClick={this.onCopyClicked} data-clipboard-text={discountCode}>{copied ? "Copied" : "Copy"}</button>
                                    { discountDesc && <p className="announcement-discount-code-desc">{discountDesc}</p>}</div>
                                </div>
                            }
                            {
                                invalidPostcode &&
                                <div>
                                    <h4>Invalid Postcode</h4>
                                    <p>You entered an invalid postcode. Please try again.</p>
                                    <hr />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {

    return {
        
    };
})(CollectionPromo);